//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commNav from '@/components/nav/index.vue'
import empty from '@/components/empty/index.vue'
import { setTimeout } from 'timers';
    export default {
        components: {
            commNav,
            empty
        },
        data() {
            return {
              counts:'',//医生数
                page:1,             //页码
                datalist:[],        //详情卡数据
                pagination:1,//请求数据
                heightof:"-90",
                message: '暂无医生',
                displayshow: false,
                skillData: [],
                noDataText: '',
                total: 0,
                skillname: '',
                doctorname: this.$store.state.doctorSearch?this.$store.state.doctorSearch:'',
                type: '',
                img: {
                    'background-image': ''
                }
            }
        },
        methods:{
            refresh(done){
                setTimeout(()=>{
                    this.skillname = '';
//                    this.doctorname =this.doctorname;
                    this.pagination = 1;
                    this.type = 'first';
                    this.getDoctors(done);
                },50)
            },
            infinite(done){
                this.pagination++;
                setTimeout(()=>{
                    this.$refs.my_scroller.finishInfinite(true);
                    if(this.pagination > this.total){
                        this.noDataText = '暂无更多结果';
                    }else{
                        this.type = '';
                        this.getDoctors(done);
                    }
                },50)
            },
            itemClick(id){
                this.$store.state.AllOfValue.doctorId = id;
                var heights = this.$refs.my_scroller.getPosition().top;
                this.$store.state.scrollerTop = heights;
                this.$store.state.doctorList = this.datalist;
                this.$store.state.pagination = this.pagination;
                this.$store.state.total = this.total;
                this.$store.state.counts = this.counts;
                this.$router.push({ path: "/doctorDetails", query: { state: 'g8t7r3'} });
            },
            query(){
                if(this.$store.state.doctorList != ''){
                    this.datalist = this.$store.state.doctorList;
                    this.$nextTick(function(){
                        this.pagination = this.$store.state.pagination;
                        this.total = this.$store.state.total;
                        this.counts = this.$store.state.counts;
                        setTimeout(()=>{
                            this.$refs.my_scroller.scrollTo(0,this.$store.state.scrollerTop,false);
                        },10);
                        this.$store.state.doctorList = [];
                    });
                }else{
//                    this.pagination = 1;
//                    this.getDoctors();
                  this.refresh();
                }
            },
            getDoctors(done){
//              console.log(this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId)
                var data = {
                    pagination: this.pagination,
                    condition: {
                        patientid: this.$store.state.userInfo.id,
//                        patientid: this.$store.state.AllOfValue.ImDoctorInfo!=undefined ?this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId:this.$store.state.userInfo.id,
                        skillname: this.skillname,
                        doctornamel: this.doctorname
                    }
                }
                this.$doRequest("/api/Inquiry/lookingFamousDoctor",data,res => {
                  if(res.parameters.length==0){
                    this.datalist=[]
                  }else{
                    if(this.type == 'first'){
                      for(var i=0;i<res.parameters.rows.length;i++){
                        if(
                          res.parameters.rows[i].commentscore
                        ){
                          res.parameters.rows[i].commentscore= res.parameters.rows[i].commentscore.toFixed(1);
                        }
                        if(res.parameters.rows[i].skillname != null){
                          res.parameters.rows[i].skillname = res.parameters.rows[i].skillname.split(',');
                          res.parameters.rows[i].style = {
                            'background-image': 'url('+res.parameters.rows[i].headphoto+')'
                          }
                        }
                      }
                      this.datalist = res.parameters.rows;
                      this.counts=res.parameters.records;
                    }else{
                      for(var i=0;i<res.parameters.rows.length;i++){
                        if(
                          res.parameters.rows[i].commentscore
                        ){
                          res.parameters.rows[i].commentscore= res.parameters.rows[i].commentscore.toFixed(1);
                        }
                        if(res.parameters.rows[i].skillname != null){
                          res.parameters.rows[i].skillname = res.parameters.rows[i].skillname.split(',');
                          res.parameters.rows[i].style = {
                            'background-image': 'url('+res.parameters.rows[i].headphoto+')'
                          }
                        }
                        this.datalist.push(res.parameters.rows[i]);
                      }
                      this.counts=res.parameters.records;
                    }
                    this.total = res.parameters.total;
                    if(typeof(done) == 'function'){
                      done();
                    }
                  }

                });
            },
            querySkill(){
                this.$doRequest('/api/doctorConfirmRest/goodAtList?type=2',null,res=>{
                    this.skillData = res.parameters;
                })
            },
            queryItem(name){
                this.skillname = name;
                this.pagination = 1;
                this.type = 'first';
                this.displayshow = false;
                this.getDoctors();
            },
            queryDoctor(){
                this.$store.state.doctorSearch=this.doctorname;
                this.skillname =null;
                this.pagination = 1;
                this.type = 'first';
                this.displayshow = false;
                this.$refs.inputs.blur();
                this.getDoctors();
              if(this.doctorname!=''){
                var searchhistory=JSON.parse(localStorage.getItem("searchhistory"))!=null?JSON.parse(localStorage.getItem("searchhistory")):[];
                searchhistory.unshift(this.doctorname);
                this.searchhistory=Array.from(new Set(searchhistory));
                if(this.searchhistory.length>15){
                  this.searchhistory.splice(15,1);
                }
                localStorage.removeItem("searchhistory");
                localStorage.setItem("searchhistory", JSON.stringify(this.searchhistory));
              }
            }
        },
        //生命周期之挂载完成
        mounted: function() {

        },
        //生命周期之创建完成
        created: function() {
            document.title = '找名医'
            this.doctorname=this.$store.state.doctorSearch?this.$store.state.doctorSearch:'';
            if(this.$route.query&&this.$route.query.befrom!=""){
                this.isroute = !!(this.$route.query.befrom == 'myOrderList');
            }
            this.$isLogin(window.location.search.substr(1), this.query);
        },
        //生命周期之更新
        updated: function () {

        },
        //生命周期之销毁
        destroyed: function () {

        }
    }



// WEBPACK FOOTER //
// ./src/views/doctor/index.vue